<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    title="拍照查看"
    custom-class="photo-dialog"
    :show-close="true"
    append-to-body
    @close="handleClose"
  >
    <div class="photo-content">
      <!-- 上部分：按钮区域 -->
      <div class="photo-buttons">
        <el-button type="primary" @click="sendPhotoCommand" :loading="isSendingCommand">
          发送拍照指令
        </el-button>
        <el-button type="success" @click="sendPhotoInitCommand" :loading="isSendingInitCommand">
          发送初始化相机指令
        </el-button>
      </div>

      <!-- 下部分：拍摄结果展示区域 -->
      <div class="photo-result">
        <div v-if="!photoStatus" class="photo-placeholder">未拍摄</div>
        <div v-else-if="photoStatus === 'shooting'" class="photo-loading">
          <i class="el-icon-loading"></i>
          <span>拍摄中...</span>
        </div>
        <div v-else-if="photoStatus === 'success' && capturedImage" class="photo-image">
          <img :src="capturedImage" alt="拍摄图片" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PhotoDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    devNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      photoStatus: '', // 'shooting', 'success', ''
      capturedImage: '',
      isSendingCommand: false,
      isSendingInitCommand: false,
      queryTimer: null,
      queryCount: 0,
      maxQueryCount: 10
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.resetStatus()
        }
      },
      immediate: true
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    // 重置状态
    resetStatus() {
      this.photoStatus = ''
      this.capturedImage = ''
      this.clearQueryTimer()
    },
    // 发送拍照指令
    sendPhotoCommand() {
      this.isSendingCommand = true
      axios.post('/device/command/photo', null, {
        params: { devNo: this.devNo }
      }).then(response => {
        let res = response.data
        if (res.code === 200) {
          this.$message.success('拍照指令发送成功')
          this.photoStatus = 'shooting'
          this.capturedImage = ''
          this.startQueryPhoto()
        } else {
          this.$message.error('拍照指令发送失败：' + (res.message || '未知错误'))
        }
      }).catch(error => {
        console.error('发送拍照指令失败:', error)
        this.$message.error('发送拍照指令失败：' + (error.message || '网络错误'))
      }).finally(() => {
        this.isSendingCommand = false
      })
    },
    // 发送初始化相机指令
    sendPhotoInitCommand() {
      this.isSendingInitCommand = true
      axios.post('/device/command/photoInit', null, {
        params: { devNo: this.devNo }
      }).then(response => {
        let res = response.data
        if (res.code === 200) {
          this.$message.success('初始化相机指令发送成功')
        } else {
          this.$message.error('初始化相机指令发送失败：' + (res.message || '未知错误'))
        }
      }).catch(error => {
        console.error('发送初始化相机指令失败:', error)
        this.$message.error('发送初始化相机指令失败：' + (error.message || '网络错误'))
      }).finally(() => {
        this.isSendingInitCommand = false
      })
    },
    // 开始查询拍摄结果
    startQueryPhoto() {
      this.queryCount = 0
      this.clearQueryTimer()
      
      this.queryTimer = setInterval(() => {
        this.queryPhotoResult()
      }, 1000)
    },
    // 查询拍摄结果
    async queryPhotoResult() {
      this.queryCount++
      
      try {
        const response = await axios.get('/device/getImg', {
          params: { devNo: this.devNo },
          headers: { 'accept': '*/*' }
        })
        
        if (response.data.code === 200 && response.data.data) {
          // 查询到图片，停止查询
          this.capturedImage = response.data.data
          this.photoStatus = 'success'
          this.clearQueryTimer()
          this.$message.success('拍摄完成')
        } else if (this.queryCount >= this.maxQueryCount) {
          // 达到最大查询次数，停止查询
          this.clearQueryTimer()
          this.photoStatus = ''
          this.$message.warning('拍摄超时，请重试')
        }
        // 否则继续查询
      } catch (error) {
        console.error('查询拍摄结果失败:', error)
        if (this.queryCount >= this.maxQueryCount) {
          this.clearQueryTimer()
          this.photoStatus = ''
          this.$message.error('查询拍摄结果失败')
        }
      }
    },
    // 清除查询定时器
    clearQueryTimer() {
      if (this.queryTimer) {
        clearInterval(this.queryTimer)
        this.queryTimer = null
      }
      this.queryCount = 0
    },
    // 关闭弹窗
    handleClose() {
      this.clearQueryTimer()
      this.$emit('update:visible', false)
    }
  },
  beforeDestroy() {
    this.clearQueryTimer()
  }
}
</script>

<style lang="less" scoped>
/deep/ .photo-dialog {
  .photo-content {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .photo-buttons {
      display: flex;
      gap: 16px;
      justify-content: center;
      padding: 16px 0;
      border-bottom: 1px solid #e5e5e5;
    }

    .photo-result {
      min-height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f5f7fa;
      border-radius: 8px;
      padding: 20px;

      .photo-placeholder {
        font-size: 16px;
        color: #999;
      }

      .photo-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        font-size: 16px;
        color: #409eff;

        i {
          font-size: 32px;
        }
      }

      .photo-image {
        width: 100%;
        display: flex;
        justify-content: center;

        img {
          max-width: 100%;
          max-height: 500px;
          object-fit: contain;
          border-radius: 4px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
}
</style>
